<div class="relative">
  <textarea
    [id]="inputId()"
    [placeholder]="placeholder()"
    [formControl]="control()"
    [rows]="rows()"
    class="om-textarea"
    [ngClass]="sizeClass()"
    [attr.maxlength]="maxLength() > 0 ? maxLength() : null"
  ></textarea>

  @if (showCounter() && maxLength() > 0 && control().value?.length > 0) {
  <p class="mt-1.5 text-xs text-slate-400 dark:text-slate-500 text-right">
    {{ control().value.length }} / {{ maxLength() }}
  </p>
  }
</div>
